import React from "react";
import { fetchCompanyDetail, fetchNogaDetail } from "./dataFetching";
import { SURVEY_YEAR } from "pages/Evaluations/KeyFigures/kpiConfiguration";

function extractActiveFilters(overheadFilters, filterId, isInitialLoad) {
  const DEFAULT_ITEMS = [];
  let filter = overheadFilters.filters.find((e) => e.id === filterId);
  if (filter.id === "surveyYears") {
    return [SURVEY_YEAR];
  }
  if (filter.id === "greaterRegion") {
    let items = filter.items.filter((e) => e.active).map((e) => e.name);

    return items;
  }
  if (isInitialLoad) {
    return DEFAULT_ITEMS;
  }
  if (filter) {
    let items = filter.items.filter((e) => e.active).map((e) => e.id);

    return items;
  }
  return DEFAULT_ITEMS;
}

export function extractRequestBodyFromFilters(overheadFilters, isInitialLoad) {
  let years = [SURVEY_YEAR];
  const nogaCodes = extractActiveFilters(overheadFilters, "nogaCode", isInitialLoad);
  const officeSizeIds = extractActiveFilters(overheadFilters, "officeSize", isInitialLoad);
  const greaterRegions = extractActiveFilters(overheadFilters, "greaterRegion", isInitialLoad);
  let body = {
    years,
    nogaCodes,
    officeSizeIds,
    greaterRegions,
  };
  return body;
}

async function setInitialActiveNoga(filtersCopy, languageKey, nogaFilterIndex, companyAccess) {
  let onError = (err) => console.log(err);
  let companyDetail = await fetchCompanyDetail(onError, companyAccess);
  let { nogaId } = companyDetail.data[0];
  let nogaDetails = await fetchNogaDetail(languageKey, nogaId, onError);
  let { nogaCode } = nogaDetails.data;
  if (nogaFilterIndex !== -1) {
    filtersCopy.filters[nogaFilterIndex].items = filtersCopy.filters[nogaFilterIndex].items.map((option) => ({
      ...option,
      active: option.id === nogaCode,
    }));
    const noActiveNogas = filtersCopy.filters[nogaFilterIndex].items.every((item) => !item.active);
    if (noActiveNogas) {
      activateDefaultNogaCode(filtersCopy, nogaFilterIndex);
    }
  }
  return filtersCopy;
}

function activateDefaultNogaCode(filtersCopy, nogaFilterIndex) {
  const ARCHI_OFFICE_NOGA_CODE = 711101;
  filtersCopy.filters[nogaFilterIndex].items = filtersCopy.filters[nogaFilterIndex].items.map((option) => ({
    ...option,
    active: option.id === ARCHI_OFFICE_NOGA_CODE,
  }));
  return filtersCopy;
}

function updateFilterItems(filtersCopy, filter, submitedFilters, nextAvailableFilters, translate) {
  let updatedFilterItems =
    filtersCopy.allAvailabeFilters[filter.id]?.map((item) => {
      let dropDownOption = {};
      if (filter.id === "nogaCode") {
        dropDownOption = {
          ...item,
          active: submitedFilters[filter.id].includes(item.id),
        };
        return dropDownOption;
      }
      if (filter.id === "officeSize") {
        dropDownOption = {
          ...item,
          active: submitedFilters[filter.id].includes(item.id),
        };
        return dropDownOption;
      }
      if (filter.id === "surveyYears") {
        dropDownOption = { id: item, label: item, active: submitedFilters[filter.id].includes(item) };
        return dropDownOption;
      }
      if (filter.id === "greaterRegion") {
        dropDownOption = {
          ...item,
          active: submitedFilters[filter.id].includes(item.name),
        };
        return dropDownOption;
      }
    }) || [];
  return updatedFilterItems;
}

export async function updateFilters(filters, submitedFilters, nextAvailableFilters, isInitialLoad, isMasterKeyValid, languageKey, translate) {
  let filtersCopy = { ...filters };

  if (isInitialLoad) {
    filtersCopy.allAvailabeFilters = nextAvailableFilters;
  }

  filtersCopy.filters = filtersCopy.filters.map((filter) => {
    let filterCopy = { ...filter };
    filterCopy.items = updateFilterItems(filtersCopy, filter, submitedFilters, nextAvailableFilters, translate);
    return filterCopy;
  });

  let nogaFilterIndex = filtersCopy.filters.findIndex((e) => e.id === "nogaCode");

  if (isInitialLoad && isMasterKeyValid) {
    filtersCopy = await setInitialActiveNoga(filtersCopy, languageKey, nogaFilterIndex, isMasterKeyValid);
    return { ...filtersCopy, newest: true, isInitialLoad: false };
  } else if (isInitialLoad && !isMasterKeyValid) {
    filtersCopy = activateDefaultNogaCode(filtersCopy, nogaFilterIndex);
    return { ...filtersCopy, newest: true, isInitialLoad: false };
  }
  return { ...filtersCopy, newest: false, isInitialLoad: false };
}
